import Router from 'next/router'

import { setGoNativeUserId } from '@front/logic/gonative'
import { windowLocation } from '@front/logic/others/windowLocation'
import { segmentReset } from '@front/logic/segment'
import { removeAnalyticsScript } from '@front/logic/segment/removeAnalyticsScript'
import { getRuntimeConfig } from '@front/runtime-config'

import { NoInterceptorAxiosInstance } from '../../axios/axios.instance'
import { queryClient } from '../../react-query/queryClient'

import { clearCookies } from './clearCookies'

const revokeAccess = async () => {
  const {
    public: { monorepoBffWorkerURL },
  } = getRuntimeConfig()
  try {
    await NoInterceptorAxiosInstance.post(
      `${monorepoBffWorkerURL}/logout`,
      undefined,
    )
  } catch (error) {
    console.error(error)
  }
}

// TODO: make this useLogoutUser hook
export const logoutUser = async (
  {
    shouldRevokeAccess,
    shouldRedirectToWelcomePage,
    isForcedLogout,
    redirect,
  }: {
    shouldRevokeAccess?: boolean
    shouldRedirectToWelcomePage?: boolean
    isForcedLogout?: boolean
    redirect?: string
  } = {
    shouldRevokeAccess: true,
    shouldRedirectToWelcomePage: true,
    isForcedLogout: false,
  },
): Promise<void> => {
  segmentReset()
  removeAnalyticsScript()
  // TODO(chapter-front): replace localStorage by useLocalStorage
  // eslint-disable-next-line no-restricted-syntax
  localStorage.removeItem('hiddenPoolCard')
  sessionStorage.removeItem('hubloOffersFilterSelectedNetworks')
  sessionStorage.removeItem('hubloOffersFilterSelectedShiftPeriods')
  // eslint-disable-next-line no-restricted-syntax
  localStorage.removeItem('accessToken')
  // eslint-disable-next-line no-restricted-syntax
  localStorage.removeItem('downloadAppBannerClosedUntil')
  // eslint-disable-next-line no-restricted-syntax
  localStorage.setItem('isLoggedIn', 'false')

  const redirectUrl = redirect ?? windowLocation.href
  setGoNativeUserId(null, null)

  if (shouldRevokeAccess) {
    await revokeAccess()
  }

  // clearing potential cookie residuals
  void clearCookies()
  queryClient.removeQueries()

  if (!redirectUrl.includes('login')) {
    if (isForcedLogout) {
      void Router.push(`/worker/login?redirectUrl=${redirectUrl}`)
    } else {
      void Router.push(shouldRedirectToWelcomePage ? `/login` : `/worker/login`)
    }
  }
}
